import {useCallback} from 'react';
import {useNavigate} from 'react-router';
import {Box, Button, Heading, Text} from '@flixbus/honeycomb-react';
import {RegionalCostsPath} from '@/Pages/RegionalCosts/constants/routePaths';

const RegionalCostsDriverCostHelpBox: React.FC = () => {
  const navigate = useNavigate();
  const goToDriverSalary = useCallback(
    () =>
      navigate({
        pathname: `/${RegionalCostsPath.driverSalaryPeriods}`,
        search: location.search
      }),
    [navigate]
  );

  return (
    <>
      <Heading size={3} sectionHeader>
        Customise salary periods by hours and shifts
      </Heading>
      <Box extraClasses="regional-costs-help-box">
        <Text Elem="div">
          You can define specific working hours and days for each salary period.
          For example, set different rates for weekdays, weekends, or night
          shifts. <br />
          We’ll automatically calculate the base salary based on your settings
          and the driver’s scheduled hours.
        </Text>

        <Button onClick={goToDriverSalary}>
          Customise driver salary periods
        </Button>
      </Box>
    </>
  );
};

export default RegionalCostsDriverCostHelpBox;
